import { Fragment, useEffect, useState } from "react";
import { useRouter } from "next/router";
import style from "./product_carousel.module.css";
import Image from "next/image";
import Carousel from "react-elastic-carousel";
import { commaFormat } from "@/helpers/utility/number_utility";
import { className as cx } from "@/helpers/utility/class_name";
import { useQuery } from "@apollo/client";
import { GetCollectionBySlug } from "@/graphql/query/collections";
import _, { filter } from "underscore";
import { Skeleton } from "@mui/material";

function ProductCarousel({ productList }) {
  const router = useRouter();
  const noArrow = ({ type, onClick, isEdge }) => {
    return <Fragment></Fragment>;
  };
  const breakPoint = [
    { width: 1, itemsToShow: 1.2 },
    { width: 600, itemsToShow: 2.2 },
    { width: 900, itemsToShow: 4 },
  ];

  const onProductClickHandler = (e, slug) => {
    router.push(`/products/${slug}`);
  };

  useEffect(() => {
    const pdElemImgWrapper = document.querySelectorAll(".image_wrapper");
    const setHeight = (elem) => {
      elem.forEach((dom) => {
        const width = Math.round(dom.getBoundingClientRect().width);
        dom.style.height = width + "px";
      });
    };
    setTimeout(() => {
      setHeight(pdElemImgWrapper);
    }, 100);
    window.addEventListener("resize", () => {
      setTimeout(() => {
        setHeight(pdElemImgWrapper);
      }, 100);
    });
  }, [productList]);

  return (
    <Fragment>
      <div className={style.product_carousel}>
        <h2 className={style.title}>แผนความคุ้มครอง</h2>
        <div className={style.carousel}>
          <Carousel showEmptySlots itemPadding={[0, 12]} renderArrow={noArrow} breakPoints={breakPoint}>
            {productList ? (
              productList.map((product, index) => (
                <div key={index} className={style.product_card} onClick={(e) => onProductClickHandler(e, product.slug)}>
                  <div className={cx(style.product_image_wrapper, "image_wrapper")}>
                    <Image alt={product.tile} src={product.image} layout="fill" objectFit="contain" />
                  </div>
                  <div className={style.product_details}>
                    <h4>{product.title}</h4>
                    <p>เบี้ยเริ่มต้น {commaFormat(product.price)} บาท </p>
                  </div>
                </div>
              ))
            ) : (
              _.range(4).map((index) => (
                <div className={style.skeleton_card} key={index}>
                  <Skeleton variant="rectangular" width={"100%"} height={225} />
                  <div>
                    <Skeleton variant="text" sx={{ fontSize: '1.125rem' }} />
                    <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                  </div>
                </div>
              ))
            )}
          </Carousel>
        </div>
      </div>
    </Fragment>
  );
}

export default function ProductCarouselContainer() {
  const { data } = useQuery(GetCollectionBySlug, {
    variables: {
      apiKey: process.env.NEXT_PUBLIC_HOME_COLLECTION_API_KEY,
      slug: "landing-page-product"
    },
  });

  const [productList, setProductList] = useState();
  useEffect(() => {
    if (!data) return

    const _filteredPackages = data.getCollectionBySlug.packages?.filter(_package => _package.status === 1) ?? []
    const _productsRemap = _filteredPackages?.map((_package) => {
      const priceArr = _package.products[0]?.product_variants?.[0]?.plan_product_variants
      const priceList = priceArr?.map(
        (planVariant) => planVariant.premium_price
      );

      return {
        slug: _package?.slug ?? "",
        id: _package?.products?.[0]?.id ?? "",
        image: _package?.thumbnail ?? "",
        price: !priceList ? "" : Math.min(...priceList) ?? "",
        title: _package?.name ?? "",
      };
    }) ?? [];

    setProductList(_productsRemap);
  }, [data]);
  return (
    <ProductCarousel productList={productList} />
  )
}
